import { lazy } from 'react';

const LazyTenantManagement = lazy(() => import('./tenant-management'));
export default LazyTenantManagement;
